import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsFetching, SelectShowCloudAgents } from 'store/Agents/selectors';
import { selectIsFiltering } from 'store/Filters/selectors';
import { RUNNERS_ENTITY, SECURITY_SCANNERS_ENTITY } from 'store/Agents/reducer';
import isEmpty from 'lodash/isEmpty';
import Wrapper from './styled';
import EmptyAgents from './components/EmptyAgents';
import NoSearchResults from 'Common/Components/NoSearchResults';
import UserAgents from './components/UserAgents';
import { getCloudAgents, getUserAgents } from 'store/Agents/actions';

const Grid = ({ agents }) => {
  const isFetching = useSelector(selectIsFetching);
  const showCloudAgents = useSelector(SelectShowCloudAgents);
  const dispatch = useDispatch();
  const noAgents = isEmpty(agents) && !isFetching;
  const isFiltering = useSelector((state) => selectIsFiltering(showCloudAgents ? SECURITY_SCANNERS_ENTITY : RUNNERS_ENTITY, state));

  useEffect(() => {
    if (showCloudAgents) dispatch(getCloudAgents());
    else dispatch(getUserAgents());
  }, [showCloudAgents, dispatch]);

  if (noAgents) {
    return (
      <Wrapper>
        { isFiltering ? <NoSearchResults /> : <EmptyAgents /> }
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <UserAgents agents={ agents } />
    </Wrapper>
  );
};

export default Grid;
